import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { ArrowLeft, ScanBarcode } from 'lucide-react'

import { ProductLotQuickStockIn } from '@/components/product-lots/ProductLotQuickStockIn'
import { Button } from '@/components/ui/button'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/quick',
)({
    component: QuickProductLotStockInPage,
})

function QuickProductLotStockInPage() {
    const navigate = useNavigate()

    return (
        <div className="space-y-4 p-4 md:p-6">
            <div className="flex items-center gap-3">
                <Button
                    variant="ghost"
                    size="sm"
                    onClick={() =>
                        void navigate({
                            to: '/sales-warehouse/stock-in-notes',
                            search: { page: 1 },
                        })
                    }
                >
                    <ArrowLeft className="size-4 mr-1" />
                    {m.sl_lot_back()}
                </Button>
                <div className="flex items-center gap-2">
                    <ScanBarcode className="size-5" />
                    <h1 className="text-xl font-semibold">
                        {m.warehouse_quick_stock_in()}
                    </h1>
                </div>
            </div>

            <div className="max-w-2xl rounded-md border bg-card p-4">
                <ProductLotQuickStockIn />
            </div>
        </div>
    )
}
